var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Slice is to keep prepared data from parsed url parts (urlParams or queryParams)
 */
import { createSlice } from '@reduxjs/toolkit';
import pick from 'lodash/pick';
import { asSliceSelectors } from '../types';
var SLICE_NAME = 'initialData';
var initialState = {
    isOwnFlowBlocked: false,
    customerIp: null,
    referralData: null,
};
var rawSlice = createSlice({
    name: SLICE_NAME,
    initialState: initialState,
    reducers: {
        setReferralData: function (state, action) {
            state.referralData = action.payload;
        },
        resetReferralData: function (state) {
            state.referralData = null;
        },
    },
});
var selectors = asSliceSelectors({
    getCustomerIp: function (state) { return state[SLICE_NAME].customerIp; },
    getLoanCategory: function (state) { return state[SLICE_NAME].loanCategory; },
    getPurposeOfUse: function (state) { return state[SLICE_NAME].purposeOfUse; },
    getPlacementId: function (state) { return state[SLICE_NAME].placementId; },
    getSmavaCustomerNumber: function (state) { return state[SLICE_NAME].smavaCustomerNumber; },
    getAmount: function (state) { return state[SLICE_NAME].amount; },
    getDuration: function (state) { return state[SLICE_NAME].duration; },
    // @note: Contains customer's metaData, that is required to be passed to own API
    getSourceCaseMeta: function (state) {
        // @todo [reselect]
        return {
            loanCategory: selectors.getLoanCategory(state),
            smavaCustomerNumber: selectors.getSmavaCustomerNumber(state),
            placementId: selectors.getPlacementId(state),
            customerIp: selectors.getCustomerIp(state),
            audienceMarkerMeta: selectors.getAudienceMarkerMeta(state),
            switchingBucket: selectors.getSwitchingBucket(state),
            isCRMLead: selectors.getIsCRMLead(state),
            referralData: selectors.getReferralData(state),
        };
    },
    getAudienceMarkerMeta: function (state) {
        // @todo [reselect]
        return pick(state[SLICE_NAME], [
            'placementId',
            'utm_source',
            'utm_medium',
            'utm_campaign',
        ]);
    },
    getUtmTerm: function (state) { return state[SLICE_NAME].utm_term; },
    getSwitchingBucket: function (state) { return state[SLICE_NAME].switchingBucket; },
    getIsTestMode: function (state) { return state[SLICE_NAME].isTestMode; },
    getIsBlockingIgnored: function (state) { return state[SLICE_NAME].isBlockingIgnored; },
    getIsOwnFlowBlocked: function (state) { return state[SLICE_NAME].isOwnFlowBlocked; },
    getIsCustomerAbleReachOwnFlow: function (state) {
        return !selectors.getIsOwnFlowBlocked(state) ||
            !!selectors.getIsBlockingIgnored(state);
    },
    getIsCRMLead: function (state) { return state[SLICE_NAME].isCRMLead; },
    getReferralData: function (state) { return state[SLICE_NAME].referralData; },
});
export var initialDataSlice = {
    name: SLICE_NAME,
    actions: __assign({}, rawSlice.actions),
    selectors: selectors,
};
export default rawSlice.reducer;
